import React, { ReactNode } from 'react';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { useParams } from 'react-router-dom';
import { BroadcastEditor } from '../../components';
import { useQuery } from '@apollo/client';
import { broadcastApi } from 'modules/broadcasts/api';
import { ViewBroadcastDialog } from '../../dialogs';
import { ModalsKeys } from 'global';

const modals: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.ViewBroadcastDialog]: <ViewBroadcastDialog />,
};

export const BroadcastEditorPage = () => {
  const { broadcastId } = useParams<{ broadcastId: string }>();

  const { data, loading, error } = useQuery(broadcastApi.getBroadcastById, {
    skip: !broadcastId,
    variables: {
      broadcastId,
    },
  });

  const broadcast = data?.broadcast?.broadcastById;

  return (
    <PageContainer loading={loading} error={error} modals={modals}>
      <BroadcastEditor broadcast={broadcast} />
    </PageContainer>
  );
};
